// "use client";

// import { IconX } from "@tabler/icons-react";
// import RoleToggle from "../../../components/RoleToggle";
// import { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import VariableTextareaField from "./VariableTextarea";
// import formatDate from "../../../utilities/helper";
// import { useFetchShipmentNotificationTemplateById } from "../../../apis/tamplateNotification";

// type ShipmentTemplate = {
//   id: string;
//   orderStatus: string;
//   channels: string[];
//   languages: string[];
//   messageEnglish?: string;
//   messageArabic?: string;
//   createdBy: string;
//   createdAt: string;
// };

// type Props = {
//   open: boolean;
//   template: any;
//   mode: "view" | "edit";
//   onEdit: () => void;
//   onClose: () => void;
// };

// const roles = ["Details", "History"];

// type FormValues = {
//   messageEnglish?: string;
//   messageArabic?: string;
// };

// const ViewShipmentNotificationModal = ({
//   open,
//   onClose,
//   template,
// }: Props) => {
//   const [activeRole, setActiveRole] = useState("Details");

//   const { data: response, isLoading } =
//     useFetchShipmentNotificationTemplateById(template as string);

//   const data = response as ShipmentTemplate | undefined;

//   if (!open) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
//       <div className="bg-[#F7F6F2] rounded-3xl lg:w-[800px] w-11/12 overflow-hidden">
//         {/* Header */}
//         <div className="flex items-center justify-between px-4 py-3 border-b">
//           <h2 className="text-lg font-medium">
//             Shipment Notification Template
//           </h2>
//           <button onClick={onClose} className="p-2 border rounded-full">
//             <IconX size={20} />
//           </button>
//         </div>

//         <div className="px-4 py-4 space-y-4">
//           <div className="flex justify-center">
//             <RoleToggle
//               options={roles}
//               active={activeRole}
//               onChange={setActiveRole}
//             />
//           </div>

//           {isLoading ? (
//             <p className="text-center py-10">Loading...</p>
//           ) : (
//             <>
//               {activeRole === "Details" && data && (
//                 <>
//                   <div className="grid grid-cols-2 gap-4 bg-white p-4 rounded-xl border">
//                     <p>
//                       <b>Event:</b> {data.orderStatus.replace(/_/g, " ")}
//                     </p>
//                     <p>
//                       <b>Created By:</b> {data.createdBy}
//                     </p>
//                     <p>
//                       <b>Channels:</b> {data.channels.join(", ")}
//                     </p>
//                     <p>
//                       <b>Languages:</b> {data.languages.join(", ")}
//                     </p>
//                     <p>
//                       <b>Created At:</b> {formatDate(data.createdAt)}
//                     </p>
//                   </div>

//                   <div className="grid grid-cols-2 gap-4">
//                     <div>
//                       <label className="text-sm font-medium text-gray-700">
//                         English Message
//                       </label>
//                       <textarea
//                         value={data.messageEnglish || ""}
//                         readOnly
//                         rows={5}
//                         className="w-full mt-1 p-3 border rounded-xl bg-gray-100 text-sm resize-none"
//                       />
//                     </div>

//                     <div>
//                       <label className="text-sm font-medium text-gray-700">
//                         Arabic Message
//                       </label>
//                       <textarea
//                         value={data.messageArabic || ""}
//                         readOnly
//                         rows={5}
//                         className="w-full mt-1 p-3 border rounded-xl bg-gray-100 text-sm resize-none"
//                       />
//                     </div>
//                   </div>
//                 </>
//               )}

//               {activeRole === "History" && (
//                 <p className="text-center text-gray-500 py-10">
//                   No history available
//                 </p>
//               )}
//             </>
//           )}
//         </div>

//         <div className="border-t px-4 py-4 flex justify-end">
//           <button
//             onClick={onClose}
//             className="px-6 py-2 bg-[#FBD037] rounded-full"
//           >
//             Close
//           </button>
//           {mode === "view" && (
//   <button
//     className="px-6 py-2 bg-[#FBD037] rounded-full"
//     onClick={onEdit}
//   >
//     Edit
//   </button>
// )}

//         </div>
//       </div>
//     </div>
//   );
// };

// export default ViewShipmentNotificationModal;

"use client";
import { IconX } from "@tabler/icons-react";
import RoleToggle from "../../../components/RoleToggle";
import { useState } from "react";
import formatDate from "../../../utilities/helper";
import { useFetchShipmentNotificationTemplateById } from "../../../apis/tamplateNotification";


type Props = {
  open: boolean;
  templateId: string | null;
  onEdit: () => void;
  onClose: () => void;
};

const roles = ["Details"];

const ViewShipmentNotificationModal = ({
  open,
  templateId,
  onEdit,
  onClose,
}: Props) => {
  const [activeRole, setActiveRole] = useState("Details");

  const { data: template, isLoading } =
  useFetchShipmentNotificationTemplateById(templateId || undefined);


  if (!open) return null;

  if (isLoading) {
    return <p className="text-center py-10">Loading...</p>;
  }

  if (!template) {
    return <p className="text-center py-10">No template found</p>;
  }

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-[#F7F6F2] rounded-3xl lg:w-[800px] w-11/12 overflow-hidden">
        {/* Header */}
        <div className="flex justify-between px-4 py-3 border-b">
          <h2 className="text-lg font-medium">
            Shipment Notification Template
          </h2>
          <button onClick={onClose} className="p-2 border rounded-full">
            <IconX size={20} />
          </button>
        </div>

        <div className="px-4 py-4 space-y-4">
          <div className="flex justify-center">
            <RoleToggle
              options={roles}
              active={activeRole}
              onChange={setActiveRole}
            />
          </div>

          {isLoading ? (
            <p className="text-center py-10">Loading...</p>
          ) : (
            template && (
              <>
                {activeRole === "Details" && (
                  <>
                    <div className="grid grid-cols-2 gap-4 bg-white p-4 rounded-xl border">
                      <p>
                        <b>Event:</b> {template.orderStatus.replace(/_/g, " ")}
                      </p>
                      <p>
                        <b>Created By:</b> {template.createdBy}
                      </p>
                      <p>
                        <b>Channels:</b> {template.channels.join(", ")}
                      </p>
                      <p>
                        <b>Languages:</b> {template.languages.join(", ")}
                      </p>
                      <p>
                        <b>Created At:</b> {formatDate(template.createdAt)}
                      </p>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <textarea
                        readOnly
                        rows={5}
                        value={template.messageEnglish || ""}
                        className="p-3 border rounded-xl bg-gray-100 resize-none"
                      />
                      <textarea
                        readOnly
                        rows={5}
                        value={template.messageArabic || ""}
                        className="p-3 border rounded-xl bg-gray-100 resize-none"
                      />
                    </div>
                  </>
                )}

                {activeRole === "History" && (
                  <p className="text-center py-10 text-gray-500">
                    No history available
                  </p>
                )}
              </>
            )
          )}
        </div>

        <div className="border-t px-4 py-4 flex justify-start gap-2">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-[#FBD037] rounded-full"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewShipmentNotificationModal;
